import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Input,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { withStyles } from "@mui/styles";
import { withRouter } from "react-router";
import { compose } from "redux";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/EditOutlined";
import DoneIcon from "@mui/icons-material/DoneAllTwoTone";
import RevertIcon from "@mui/icons-material/NotInterestedOutlined";
import Yup from "yup";
import resourceFactory from "common/admin/resourceFactory";
import { pick } from "lodash";
import DialogBox from "common/components/DialogBox";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/lab/Alert";
import Switch from "@mui/material/Switch";
import { useTranslation } from "react-i18next";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
  },
  selectTableCell: {
    width: 60,
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  tableCell: {
    height: 20,
    padding: "0px 4px",
  },
  input: {
    // width: 130,
    height: 20,
  },
}));
const CustomTableCell = ({ row, name, onChange, index, type = "text" }) => {
  const classes = useStyles();
  const { isEditMode } = row;
  return (
    <TableCell align="left" className={classes.tableCell}>
      {isEditMode ? (
        <Input
          type={type}
          value={row[name]}
          name={name}
          onChange={(e) => onChange(e, row, index)}
          className={classes.input}
          style={{ width: "100%" }}
        />
      ) : (
        row[name]
      )}
    </TableCell>
  );
};

const fields = ["name", "icon", "type", "action", "priority", "is_active"];

const validationSchema = (t) =>
  Yup.object().shape({
    name: Yup.string().required("Name is required"),
    icon: Yup.string().required("Icon name is required"),
    type: Yup.string().required("Type is required."),
    action: Yup.string().required("Link is required."),
    priority: Yup.number().required("Priority is required."),
  });
const superAdminValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  icon: Yup.string().required("Icon name is required"),
  type: Yup.string().required("Type is required."),
  action: Yup.string().required("Link is required."),
});
const ActionColumn = ({
  quickLink,
  updateQuickLinks,
  onRevert,
  index,
  onToggleEditMode,
  selectedRecord,
  setOpen,
  isSuperAdmin,
  toggleActivate,
  toggleEnableDisable,
  isRouteLink,
  isEnabled,
}) => {
  if (!isSuperAdmin && toggleEnableDisable) {
    return (
      <Switch
        disabled={!isEnabled}
        checked={quickLink.is_active}
        onChange={() => toggleActivate(quickLink.id, index)}
        name="checkedA"
        slotProps={{ input: { "aria-label": "primary checkbox" } }}
        color="primary"
      />
    );
  }
  if (isRouteLink || toggleEnableDisable) {
    return null;
  }
  if (quickLink.isEditMode) {
    return (
      <>
        <IconButton
          aria-label="done"
          onClick={() => updateQuickLinks(quickLink.id, index)}
        >
          <DoneIcon fontSize="small" />
        </IconButton>
        <IconButton
          aria-label="revert"
          onClick={() => onRevert(quickLink.id, index)}
        >
          <RevertIcon fontSize="small" />
        </IconButton>
      </>
    );
  }
  return (
    <>
      <IconButton
        aria-label="delete"
        onClick={() => onToggleEditMode(quickLink.id, index)}
      >
        <EditIcon fontSize="small" />
      </IconButton>
      {!isSuperAdmin ? null : (
        <IconButton
          aria-label="delete"
          onClick={() => {
            selectedRecord.current = quickLink;
            setOpen(true);
          }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      )}
    </>
  );
};

const NotificationList = ({
  quickLinks,
  data,
  classes,
  history,
  urlResource,
  removeOne,
  isSuperAdmin,
  ...props
}) => {
  const { t } = useTranslation();
  const createData = ({
    id,
    name,
    icon,
    type,
    action,
    priority,
    is_active,
  }) => {
    const obj = !isSuperAdmin ? { is_active } : {};
    return {
      id,
      name,
      icon,
      type,
      action,
      priority,
      isEditMode: false,
      ...obj,
    };
  };
  const quickLinksData = quickLinks.map(createData);
  const [rows, setRows] = React.useState(quickLinksData);
  const [open, setOpen] = React.useState(false);
  const [message, setShowMessage] = React.useState(false);
  const [previous, setPrevious] = React.useState({});
  const selectedRecord = React.useRef({});
  const onToggleEditMode = (id, index, newRow) => {
    let newRows = [...rows];
    const row = newRow || newRows[index] || {};
    if (row.isNew) {
      newRows = newRows.filter((_, currentIndex) => currentIndex !== index);
      return setRows(newRows);
    }
    newRows[index] = { ...row, isEditMode: !row.isEditMode };
    setRows(newRows);
  };
  const addNewRow = () => {
    const newRows = [...rows];
    const isNewExists = newRows.find(({ isNew }) => isNew);
    if (isNewExists) {
      return;
    }
    newRows.push({
      name: "",
      icon: "",
      type: "",
      action: "",
      priority: 1,
      isEditMode: true,
      isNew: true,
    });
    setRows(newRows);
  };
  const updateQuickLinks = async (id, index, currentDataRecord) => {
    const currentData = currentDataRecord || rows[index];
    currentData.action = currentData.action || "";
    currentData.priority = currentData.priority || 0;
    const schema = isSuperAdmin
      ? superAdminValidationSchema
      : validationSchema(t);
    const castedData = schema.cast(currentData);
    schema
      .validate(castedData)
      .then(async (value) => {
        const params = props.location.pathname.split("/") || [];
        const notificationId = params[params.length - 2];
        const actions = resourceFactory(
          isSuperAdmin
            ? "quick_link_master"
            : `buildings/${notificationId}/quick_links`,
        );
        const body = pick(castedData, fields);
        if (currentData.isNew) {
          const payload = isSuperAdmin
            ? body
            : {
                links: {
                  ...body,
                },
              };
          try {
            rows.length > 1 && !isSuperAdmin
              ? await actions.update(data.id, {
                  links: { ...body },
                })
              : await actions.create({
                  ...payload,
                });
            const newData = await actions.getAll();
            const quickLinksData = isSuperAdmin
              ? newData.map(createData)
              : newData.links.map(createData);
            setRows(quickLinksData);
            setShowMessage("New quick link successfully created!");
          } catch (e) {}
        } else {
          try {
            const payload = isSuperAdmin
              ? body
              : { links: { ...body, id: Number(id) } };
            await actions.update(isSuperAdmin ? id : data.id, {
              ...payload,
            });
            onToggleEditMode(id, index);
            setShowMessage(t("quick_links_list.update_success"));
          } catch (error) {}
        }
      })
      .catch((err) => {
        setShowMessage(err.message);
      });
  };
  const deleteRecord = async () => {
    const { id } = selectedRecord.current || {};
    if (!id) {
      return;
    }
    const params = props.location.pathname.split("/") || [];
    const notificationId = params[params.length - 2];
    const actions = resourceFactory(
      isSuperAdmin
        ? "quick_link_master"
        : `buildings/${notificationId}/quick_links`,
    );
    (await isSuperAdmin)
      ? actions.removeOne(id)
      : actions.removeOneWithBody(data.id, {
          links: { id },
        });

    const newData = await actions.getAll();
    const quickLinksData = isSuperAdmin
      ? newData.map(createData)
      : newData.links.map(createData);
    setRows(quickLinksData);
    setOpen(false);
    setShowMessage("Quick Link deleted successfully");
  };
  const onChange = (e, row, index) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const newRows = [...rows];
    newRows[index] = { ...row, [name]: value };
    setRows(newRows);
  };

  const onRevert = (id, index) => {
    const newRows = [...rows];
    newRows[index] = previous[id] || rows[index];
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEditMode(id, index, newRows[index]);
  };
  const toggleActivate = (id, index) => {
    const currentData = rows[index];
    currentData.is_active = !currentData.is_active;
    updateQuickLinks(id, index, currentData);
  };

  const getLinkType = (type, t) => {
    return t(`quick_links_list.${type}`);
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={Boolean(message)}
        autoHideDuration={2000}
        // message={message}
        onClose={() => setShowMessage("")}
      >
        <Alert onClose={() => setShowMessage("")} severity="success">
          {message}
        </Alert>
      </Snackbar>
      <DialogBox
        open={open}
        title="Delete Action"
        successButtonText="Delete"
        body="Do you want to delete the record"
        handleClose={() => {
          selectedRecord.current = {};
          setOpen(false);
        }}
        onSuccess={deleteRecord}
      ></DialogBox>
      {/* <Button
        variant="contained"
        color="primary"
        onClick={addNewRow}
        style={{ position: "absolute", right: 10, top: 10 }}
      >
        Create a Quick Link
      </Button> */}
      <Table classes={{ root: classes.root }}>
        <TableHead>
          <TableRow>
            <TableCell classes={{ root: classes.th }}>
              {t("quick_links_list.th_name")}
            </TableCell>
            <TableCell classes={{ root: classes.th }}>
              {t("quick_links_list.th_icon")}
            </TableCell>
            <TableCell classes={{ root: classes.th }}>
              {t("quick_links_list.th_type")}
            </TableCell>
            <TableCell classes={{ root: classes.th }}>
              {t("quick_links_list.th_link")}
            </TableCell>
            <TableCell classes={{ root: classes.th }}>
              {t("quick_links_list.th_priority")}
            </TableCell>
            <TableCell classes={{ root: classes.th }}>
              {t("quick_links_list.th_actions")}
            </TableCell>
            {isSuperAdmin ? null : (
              <TableCell classes={{ root: classes.th }} align="left">
                {t("quick_links_list.th_active")}
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length ? (
            rows.map((quickLink, index) => {
              return (
                <TableRow key={quickLink.id}>
                  <TableCell className={classes.td}>{quickLink.name}</TableCell>
                  <TableCell className={classes.td}>{quickLink.icon}</TableCell>
                  <TableCell className={classes.td}>
                    {getLinkType(quickLink.type, t)}
                  </TableCell>
                  {quickLink.type === "routelink" ? (
                    <TableCell className={classes.td}>
                      {quickLink.action}
                    </TableCell>
                  ) : (
                    <CustomTableCell
                      {...{ row: quickLink, name: "action", onChange, index }}
                    ></CustomTableCell>
                  )}
                  <CustomTableCell
                    {...{
                      row: quickLink,
                      type: "number",
                      name: "priority",
                      onChange,
                      index,
                    }}
                  ></CustomTableCell>
                  <TableCell className={classes.selectTableCell}>
                    <ActionColumn
                      quickLink={quickLink}
                      updateQuickLinks={updateQuickLinks}
                      onRevert={onRevert}
                      index={index}
                      onToggleEditMode={onToggleEditMode}
                      selectedRecord={selectedRecord}
                      setOpen={setOpen}
                      toggleActivate={toggleActivate}
                      isSuperAdmin={isSuperAdmin}
                      isRouteLink={quickLink.type === "routelink"}
                    />
                  </TableCell>
                  {!isSuperAdmin ? (
                    <TableCell className={classes.selectTableCell}>
                      <ActionColumn
                        quickLink={quickLink}
                        updateQuickLinks={updateQuickLinks}
                        onRevert={onRevert}
                        index={index}
                        onToggleEditMode={onToggleEditMode}
                        selectedRecord={selectedRecord}
                        setOpen={setOpen}
                        toggleActivate={toggleActivate}
                        isSuperAdmin={isSuperAdmin}
                        toggleEnableDisable
                        isEnabled={true}
                      />
                    </TableCell>
                  ) : null}
                </TableRow>
              );
            })
          ) : (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={addNewRow}
                style={{ position: "absolute", right: 10, top: 10 }}
              >
                Create a Quick Link
              </Button>
              <TableRow>
                <TableCell colSpan={6}>
                  {t("quick_links_list.no_records")}
                </TableCell>
              </TableRow>
            </>
          )}
        </TableBody>
      </Table>
    </>
  );
};

NotificationList.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      send_push_notification: PropTypes.bool,
      target: PropTypes.string.isRequired,
      available_at: PropTypes.string.isRequired,
      available_until: PropTypes.string.isRequired,
    }),
  ).isRequired,
  classes: PropTypes.object.isRequired,
  removeOne: PropTypes.func.isRequired,
};

const styles = (theme) => ({
  root: {
    padding: 0,
  },
  th: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    backgroundColor: "#7f7f7f",
    color: "#fff",
    fontWeight: "bold",
  },
  td: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  clickable: {
    cursor: "pointer",
    color: theme.palette.primary.light,
    fontWeight: "bold",
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
});

const enhanced = compose(
  withRouter,
  withStyles(styles),
  // withUrlResource,
  // withUrlResourceTimezone
);

export default enhanced(NotificationList);
